import React from 'react';
import styled from 'styled-components';
import { hexToRGB, checkPixel } from 'utils';
import { ReactComponent as Arrow } from 'assets/icons/arrow.svg';
import { ReactComponent as Check } from 'assets/icons/check.svg';
import { ReactComponent as Close } from 'assets/icons/close.svg';
import { ReactComponent as Del } from 'assets/icons/del.svg';
import { ReactComponent as Clock } from 'assets/icons/clock.svg';
import { ReactComponent as ClockPrimary } from 'assets/icons/clock_primary.svg';
import { ReactComponent as Download } from 'assets/icons/download.svg';
import { ReactComponent as File } from 'assets/icons/file.svg';
import { ReactComponent as Play } from 'assets/icons/play.svg';
import { ReactComponent as Pause } from 'assets/icons/pause.svg';
import { ReactComponent as Comment } from 'assets/icons/comment.svg';
import { ReactComponent as Address } from 'assets/icons/address.svg';
import { ReactComponent as Lock } from 'assets/icons/lock.svg';
import { ReactComponent as Tel } from 'assets/icons/tel.svg';
import { ReactComponent as Fax } from 'assets/icons/fax.svg';
import { ReactComponent as Mail } from 'assets/icons/mail.svg';
import { ReactComponent as MoMenu } from 'assets/icons/mo_menu.svg';
import { ReactComponent as SwiperArrow } from 'assets/icons/swiper_arrow.svg';
import { ReactComponent as Language } from 'assets/icons/language.svg';
import { ReactComponent as PasswordHide } from 'assets/icons/password_hide.svg';
import { ReactComponent as PasswordShow } from 'assets/icons/password_show.svg';
import { ReactComponent as More } from 'assets/icons/main/more.svg';
import { ReactComponent as Speciality1 } from 'assets/icons/main/speciality_1.svg';
import { ReactComponent as Speciality2 } from 'assets/icons/main/speciality_2.svg';
import { ReactComponent as Speciality3 } from 'assets/icons/main/speciality_3.svg';

export function Icon({ name, onClick, ...props }) {
  return (
    <IconSpan onClick={onClick} {...props}>
      {name === 'language' && <Language />}
      {name === 'arrow' && <Arrow />}
      {name === 'check' && <Check />}
      {name === 'close' && <Close />}
      {name === 'del' && <Del />}
      {name === 'lock' && <Lock />}
      {name === 'comment' && <Comment />}
      {name === 'download' && <Download />}
      {name === 'clock' && <Clock />}
      {name === 'clockPrimary' && <ClockPrimary />}
      {name === 'more' && <More />}
      {name === 'menu' && <MoMenu />}
      {name === 'file' && <File />}
      {name === 'address' && <Address />}
      {name === 'tel' && <Tel />}
      {name === 'fax' && <Fax />}
      {name === 'play' && <Play />}
      {name === 'pause' && <Pause />}
      {name === 'mail' && <Mail />}
      {name === 'swiperArrow' && <SwiperArrow />}
      {name === 'passwordHide' && <PasswordHide />}
      {name === 'passwordShow' && <PasswordShow />}
      {name === 'speciality1' && <Speciality1 />}
      {name === 'speciality2' && <Speciality2 />}
      {name === 'speciality3' && <Speciality3 />}
    </IconSpan>
  );
}
const IconSpan = styled.span`
  display: inline-block;
  line-height: 0;
  padding: ${({ $padding }) => $padding || '5px'};
  transition: all 150ms ease;
  width: fit-content;
  ${({ $transform }) => $transform && `transform:${$transform}`};
  ${({ $pointer }) => $pointer && `cursor:pointer`};
  ${({ onClick }) => onClick && `cursor:pointer`};

  & > svg {
    width: ${({ $width }) => checkPixel($width) || '14px'};
    height: ${({ $height }) => checkPixel($height) || '14px'};
    ${({ theme, $fill }) => $fill && `fill: ${hexToRGB(theme.colors[$fill] || $fill, 1)}`};
    ${({ theme, $stroke }) => $stroke && `stroke: ${hexToRGB(theme.colors[$stroke] || $stroke, 1)}`};

    & > path {
      strokeopacity: ${({ theme, $pathFill }) =>
        $pathFill && `fill: ${hexToRGB(theme.colors[$pathFill] || $pathFill, 1)};`};
      ${({ theme, $pathStroke }) => $pathStroke && `stroke: ${hexToRGB(theme.colors[$pathStroke] || $pathStroke, 1)};`};
      ${({ theme, $strokeOpacity }) =>
        $strokeOpacity && `stroke-opacity: ${hexToRGB(theme.colors[$strokeOpacity] || $strokeOpacity, 1)};`};
    }
  }
  @media ${({ theme }) => theme.device.tablet} {
    & > svg {
      ${({ $tWidth }) => $tWidth && `width: ${checkPixel($tWidth)}`};
      ${({ $tHeight }) => $tHeight && `height:${checkPixel($tHeight)}`};
    }
  }

  @media ${({ theme }) => theme.device.mobile} {
    & > svg {
      ${({ $mWidth }) => $mWidth && `width: ${checkPixel($mWidth)}`};
      ${({ $mHeight }) => $mHeight && `height:${checkPixel($mHeight)}`};
    }
  }
`;
